<template>
  <v-container v-if="$vuetify.breakpoint.lgAndUp" class="fill-height">
    <v-snackbar v-model="$route.query.logout" timeout="6000" top>
      {{ $t(`information.loggedOut`) }}
    </v-snackbar>
    <v-row justify="center">
      <v-dialog
        v-model="shouldBlockForInactivity"
        persistent
        :max-width="$vuetify.breakpoint.smAndDown ? null : '25vw'"
        class="mx-auto"
      >
        <v-card>
          <v-card-text class="text-h4 pa-4 w-4 ">
            {{ $t("information.inactiveTooLong") }}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green-darken-1"
              variant="text"
              @click="shouldBlockForInactivity = false"
            >
              Ok
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-dialog v-model="cookieError" width="500">
      <v-card>
        <v-card-title class="headline primary white--text mb-2">
          <v-icon color="white" size="30" class="mr-3"
            >mdi-information-outline</v-icon
          >
          {{ $t(`heading.familyMemberInstructions`) }}
        </v-card-title>
        <v-card-text>
          {{ $t(`error.cookiesRequired`) }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="cookieError = false">
            {{ $t(`button.close`) }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="familyModal" width="500">
      <v-card>
        <v-card-title class="headline primary white--text mb-2">
          <v-icon color="white" size="30" class="mr-3"
            >mdi-information-outline</v-icon
          >
          {{ $t(`heading.familyMemberInstructions`) }}
        </v-card-title>
        <v-card-text>
          {{ $t(`information.switchFamilyMemberInstructions`) }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="familyModal = false">
            {{ $t(`button.close`) }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row align="center" justify="center">
      <v-card width="1500px" class="pa-10" shaped
        ><v-row align="center">
          <v-col cols="6">
            <v-fade-transition mode="out-in" group hide-on-leave>
              <v-img
                v-if="step == 1"
                :key="step"
                src="https://clinicaapps.blob.core.windows.net/static/images/assets/images/app_events.png"
                max-height="500px"
                contain
                eager
              ></v-img>

              <v-img
                v-else-if="step == 2"
                :key="step"
                contain
                src="https://clinicaapps.blob.core.windows.net/static/images/assets/images/app_login.svg"
                max-height="500px"
                eager
              ></v-img>
              <v-img
                v-else
                :key="step"
                contain
                eager
                src="https://clinicaapps.blob.core.windows.net/static/images/assets/images/app_authenticate.png"
              ></v-img>
            </v-fade-transition>
          </v-col>
          <v-col cols="6">
            <v-card class="fill-height text-center" flat>
              <v-scale-transition appear>
                <v-alert v-if="error" type="error">
                  {{ $t("error.authentication") }}
                </v-alert>
              </v-scale-transition>
              <v-window v-model="step" touchless>
                <v-window-item :value="1">
                  <h1 class="display-3 primary--text text-center">
                    {{ $t("heading.welcome") }}
                  </h1>
                  <v-card-text class="body-1 font-weight-medium">
                    <!-- <span v-html="$t('information.virtualVisits')"></span>
                    <br /> -->
                    <span class="body-1 font-weight-bold primary--text pt-1">
                      {{ $t("information.established") }}
                    </span>
                  </v-card-text>

                  <v-row no-gutters>
                    <v-col cols="12">
                      <v-btn
                        class="primary__gradient"
                        rounded
                        dark
                        @click="
                          step++;
                          scrollTop();
                        "
                      >
                        {{ $t("button.establishedPatient") }}</v-btn
                      ></v-col
                    >
                    <!-- <v-col cols="12">
                      <v-btn
                        color="secondary"
                        class="mt-2"
                        text
                        href="https://managemycare.clinica.org/"
                        >{{ $t("button.newPatient") }}</v-btn
                      >
                    </v-col> -->
                  </v-row>
                  <v-row dense no-gutters>
                    <v-col
                      ><v-alert
                        text
                        color="error"
                        class="mt-4 font-weight-medium"
                        dense
                      >
                        {{ $t("information.emergency") }}
                      </v-alert></v-col
                    ></v-row
                  >
                </v-window-item>
                <v-window-item :value="2">
                  <v-row no-gutters>
                    <v-card-text>
                      <h1 class=" mb-2 primary--text">
                        {{ $t("information.enter") }}
                      </h1>
                      <p class="body-1 mb-0">
                        {{ $t("information.enteredInformation") }}
                      </p>
                      <a
                        color="primary"
                        class="body-1 font-weight-medium"
                        @click="familyModal = true"
                      >
                        <u>{{ $t(`button.loginAsFamilyMember`) }}</u>
                      </a>
                      <v-form
                        v-if="step == 2"
                        class="pt-1 text-left font-weight-medium"
                      >
                        <v-slide-y-transition>
                          <v-alert
                            v-if="notFound"
                            type="warning"
                            prominent
                            v-html="$t(`error.couldNotVerify`)"
                          >
                          </v-alert>
                          <v-alert v-if="tooManyFound" type="warning"
                            >Please provide more specific information before
                            searching again.
                          </v-alert>
                          <v-alert
                            v-if="tooManyAttempts"
                            type="error"
                            v-html="$t(`error.tooManyAttempts`)"
                          >
                          </v-alert>
                        </v-slide-y-transition>
                        <v-text-field
                          v-model="first_name"
                          :label="$t('label.firstName')"
                          name="first_name"
                          type="text"
                          outlined
                        />
                        <v-text-field
                          v-model="last_name"
                          :label="$t('label.lastName')"
                          name="last_name"
                          type="text"
                          outlined
                        />
                        <!-- <v-dialog
													ref="menu"
													v-model="menu"
													:close-on-content-click="false"
													transition="scale-transition"
													offset-y
													max-width="400px"
												>
													<template v-slot:activator="{ on }"> -->
                        <v-text-field
                          v-model="date_of_birth"
                          v-mask="'##/##/####'"
                          :label="$t('label.dob')"
                          placeholder="MM/DD/YYYY"
                          hint="MM/DD/YYYY"
                          outlined
                          type="tel"
                        ></v-text-field>
                        <!-- </template>
													<v-date-picker
														full-width
														ref="picker"
														v-model="date_of_birth"
														:max="new Date().toISOString().substr(0, 10)"
														min="1940-01-01"
														@change="save"
														:locale="$i18n.locale"
													></v-date-picker>
												</v-dialog> -->

                        <v-text-field
                          v-model="phone_number"
                          v-mask="'(###)###-####'"
                          :label="$t('label.phone')"
                          name="phone"
                          type="tel"
                          maxlength="14"
                          outlined
                        />
                      </v-form>
                    </v-card-text>
                    <v-btn
                      :loading="loading"
                      :disabled="
                        phone_number.length != 13 ||
                          !date_of_birth ||
                          !first_name ||
                          !last_name ||
                          tooManyAttempts
                      "
                      class="primary__gradient"
                      rounded
                      block
                      dark
                      @click="search()"
                    >
                      {{ $t("button.continue") }}
                    </v-btn>
                    <v-btn
                      color="error"
                      text
                      class="mt-4"
                      @click="
                        step--;
                        scrollTop();
                      "
                      >{{ $t("button.back") }}</v-btn
                    >
                  </v-row>
                </v-window-item>
                <v-window-item :value="3">
                  <v-card-text>
                    <v-slide-y-transition>
                      <v-alert
                        v-if="incorrectCode"
                        type="warning"
                        class="font-weight-medium"
                        >{{ $t("error.invalidCode") }}</v-alert
                      >
                    </v-slide-y-transition>
                    <h1 class="font-weight-medium primary--text headline">
                      {{ $t("heading.verify") }}
                    </h1>
                    <p class="body-1 text-center mt-2 font-weight-medium">
                      {{ $t("heading.enterCode") }} <br />
                      {{ phone_number }}
                    </p>
                    <v-text-field
                      v-model="verification_code"
                      :label="$t('label.code')"
                      name="verification_code"
                      loading
                      outlined
                      type="tel"
                      maxlength="6"
                      @keyup.enter="verify()"
                    >
                      <template v-slot:progress>
                        <v-progress-linear
                          :value="progress"
                          :color="color"
                          absolute
                          height="7"
                        ></v-progress-linear>
                      </template>
                    </v-text-field>
                    <v-row justify="center" no-gutters>
                      <v-btn
                        text
                        small
                        color="teal"
                        @click="resendCode(channel)"
                      >
                        {{ $t("button.resendCode") }}
                      </v-btn>

                      <v-divider
                        v-if="$vuetify.breakpoint.xlOnly"
                        class="mx-4"
                        vertical
                      ></v-divider>
                      <v-btn
                        text
                        small
                        color="teal"
                        @click="resendCode('call')"
                      >
                        {{ $t("button.resendVoice") }}
                      </v-btn>
                    </v-row>
                  </v-card-text>

                  <v-btn
                    dark
                    class="primary__gradient"
                    block
                    rounded
                    :loading="loading"
                    :disabled="verification_code.length != '6'"
                    @click="verify()"
                    >{{ $t("button.verifyCode") }}</v-btn
                  >
                  <v-btn
                    color="error"
                    text
                    class="mt-4"
                    @click="
                      step--;
                      scrollTop();
                    "
                    >{{ $t("button.back") }}</v-btn
                  >
                </v-window-item>
              </v-window>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
    </v-row>
  </v-container>
  <v-container v-else class="mt-0 pt-0">
    <v-dialog v-model="cookieError" width="500">
      <v-card>
        <v-card-title class="headline primary white--text mb-2">
          <v-icon color="white" size="30" class="mr-3"
            >mdi-information-outline</v-icon
          >
          {{ $t(`heading.familyMemberInstructions`) }}
        </v-card-title>
        <v-card-text>
          {{ $t(`error.cookiesRequired`) }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="cookieError = false">
            {{ $t(`button.close`) }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="familyModal" width="500">
      <v-card>
        <v-card-title class="headline primary white--text mb-2">
          <v-icon color="white" size="30" class="mr-3"
            >mdi-information-outline</v-icon
          >
          {{ $t(`heading.familyMemberInstructions`) }}
        </v-card-title>
        <v-card-text>
          {{ $t(`information.switchFamilyMemberInstructions`) }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="familyModal = false">
            {{ $t(`button.close`) }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-window v-model="step" touchless>
      <v-fade-transition appear>
        <v-window-item :value="1">
          <v-row justify="center" no-gutters>
            <v-img
              max-height="500px"
              class="mt-3"
              src="https://clinicaapps.blob.core.windows.net/static/images/assets/images/app_events.png"
              contain
              eager
            ></v-img>
            <v-col cols="12">
              <h1 class="primary--text text-center">
                {{ $t("heading.welcome") }}
              </h1>
            </v-col>

            <p
              class="primary--text text-center font-weight-medium"
              v-html="$t('information.established')"
            ></p>
            <!-- <p class="font-weight-medium text-center secondary--text">
              <span v-html="$t('information.virtualVisits')"></span>
            </p> -->
            <v-alert
              class="text-center font-weight-bold"
              color="primary"
              text
              dark
            >
              {{ $t("information.emergency") }}
            </v-alert>

            <v-btn
              class="primary__gradient"
              dark
              block
              rounded
              @click="
                step++;
                scrollTop();
              "
            >
              {{ $t("button.establishedPatient") }}
            </v-btn>
            <!-- <v-btn
              block
              class="mt-4"
              color="secondary"
              text
              href="https://managemycare.clinica.org/"
              >{{ $t("button.newPatient") }}</v-btn
            > -->
          </v-row>
        </v-window-item>
      </v-fade-transition>

      <v-fade-transition appear>
        <v-window-item v-if="step == 2" :value="2">
          <v-row justify="center" no-gutters>
            <!-- <v-img
              contain
              eager
              src="https://clinicaapps.blob.core.windows.net/static/images/assets/images/app_login.svg"
              max-height="200px"
            ></v-img> -->
            <v-card-text class="text-center">
              <h1 class="font-weight-medium mb-2 primary--text">
                {{ $t("information.enter") }}
              </h1>
              <p class="subtitle-1 font-weight-medium mb-0">
                {{ $t("information.enteredInformation") }}
              </p>
              <a
                color="primary"
                class="body-1 font-weight-medium"
                @click="familyModal = true"
              >
                <u>{{ $t(`button.loginAsFamilyMember`) }}</u>
              </a>
              <v-form v-if="step == 2" class="pt-4 font-weight-medium">
                <v-scale-transition appear>
                  <v-alert v-if="error" type="error" prominent>
                    {{ $t("error.authentication") }}
                  </v-alert>
                </v-scale-transition>
                <v-slide-y-transition>
                  <v-alert
                    v-if="notFound"
                    type="warning"
                    prominent
                    class="font-weight-medium"
                    v-html="$t(`error.couldNotVerify`)"
                  >
                  </v-alert>
                  <v-alert
                    v-if="tooManyAttempts"
                    class="font-weight-medium"
                    type="error"
                    v-html="$t(`error.tooManyAttempts`)"
                  >
                  </v-alert>
                  <v-alert
                    v-if="cookieError"
                    class="font-weight-medium"
                    type="error"
                    v-html="$t(`error.tooManyAttempts`)"
                  >
                  </v-alert>

                  <v-alert
                    v-if="expiredCode"
                    type="warning"
                    class="font-weight-medium"
                    >{{ $t("error.invalidCode") }}</v-alert
                  >
                </v-slide-y-transition>
                <v-text-field
                  v-model="first_name"
                  :label="$t('label.firstName')"
                  name="first_name"
                  type="text"
                  filled
                  background-color="white"
                />
                <v-text-field
                  v-model="last_name"
                  :label="$t('label.lastName')"
                  name="last_name"
                  type="text"
                  filled
                  background-color="white"
                />

                <v-text-field
                  v-model="date_of_birth"
                  v-mask="'##/##/####'"
                  :label="$t('label.dob')"
                  type="tel"
                  hint="MM/DD/YYYY"
                  filled
                  background-color="white"
                />
                <v-text-field
                  v-model="phone_number"
                  v-mask="'(###)###-####'"
                  :label="$t('label.phone')"
                  name="phone"
                  type="tel"
                  maxlength="14"
                  filled
                  background-color="white"
                />
              </v-form>
            </v-card-text>

            <v-btn
              :loading="loading"
              :disabled="
                phone_number.length != 13 ||
                  !date_of_birth ||
                  !first_name ||
                  !last_name ||
                  tooManyAttempts
              "
              class="primary__gradient"
              rounded
              dark
              block
              @click="search()"
            >
              {{ $t("button.continue") }}
            </v-btn>
            <v-btn
              color="error"
              text
              class="mt-4"
              @click="
                step--;
                scrollTop();
              "
            >
              {{ $t("button.back") }}
            </v-btn>
          </v-row>
        </v-window-item>
      </v-fade-transition>
      <v-fade-transition appear>
        <v-window-item v-if="step == 3" :value="3">
          <!-- <v-img
            eager
            max-height="500px"
            src="https://clinicaapps.blob.core.windows.net/static/images/assets/images/app_authenticate.png"
          ></v-img> -->
          <v-card-text>
            <v-slide-y-transition>
              <v-alert
                v-if="incorrectCode"
                type="warning"
                class="font-weight-medium"
                >{{ $t("error.invalidCode") }}</v-alert
              >
            </v-slide-y-transition>
            <h1 class="text-center headline primary--text font-weight-bold">
              {{ $t("heading.verify") }}
            </h1>
            <h4 class="subtitle-1 text-center font-weight-medium">
              {{ $t("heading.enterCode") }}
            </h4>
            <h4
              class="primary--text subtitle-1 text-center mb-2 font-weight-medium"
            >
              {{ phone_number }}
            </h4>
            <v-text-field
              v-model="verification_code"
              :label="$t('label.code')"
              name="verification_code"
              loading
              solo
              type="tel"
              maxlength="6"
              class="font-weight-medium"
              @keyup.enter="verify()"
            >
              <template v-slot:progress>
                <v-progress-linear
                  :value="progress"
                  :color="color"
                  absolute
                  height="7"
                ></v-progress-linear>
              </template>
            </v-text-field>
            <v-row justify="center" no-gutters>
              <v-btn text small color="teal" @click="resendCode(channel)">
                {{ $t("button.resendCode") }}
              </v-btn>

              <v-btn text small color="teal" @click="resendCode('call')">
                {{ $t("button.resendVoice") }}
              </v-btn>
            </v-row>
          </v-card-text>

          <v-btn
            color="primary__gradient"
            dark
            block
            rounded
            :loading="loading"
            :disabled="verification_code.length != '6'"
            @click="verify()"
            >{{ $t("button.verifyCode") }}</v-btn
          >
          <v-btn
            color="error"
            text
            class="mt-4"
            @click="
              step--;
              scrollTop();
            "
          >
            {{ $t("button.back") }}
          </v-btn>
        </v-window-item>
      </v-fade-transition>
    </v-window>
  </v-container>
</template>

<script>
import { mask } from "vue-the-mask";
export default {
  name: "Login",
  directives: { mask },
  data: () => ({
    step: 1,
    date_of_birth: "",
    first_name: "",
    last_name: "",
    phone_number: "",
    verification_code: "",
    notFound: false,
    tooManyFound: false,
    tooManyAttempts: false,
    cookieError: false,
    incorrectCode: false,
    expiredCode: false,
    loading: false,
    menu: false,
    personId: null,
    authToken: null,
    sessionId: null,
    error: undefined,
    channel: undefined,
    familyModal: false,
    shouldBlockForInactivity: false,
  }),
  computed: {
    progress() {
      return Math.min(100, this.verification_code.length * 16.66666);
    },
    color() {
      return ["error", "warning", "primary"][Math.floor(this.progress / 40)];
    },
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    $route(to, from) {
      if (this.$route.path == "/") {
        this.checkAuth();
      }
    },
  },
  mounted() {
    this.checkAuth();
    if (this.$route.query.family) {
      this.scrollTop();
      this.step = 2;
    }
  },
  methods: {
    scrollTop() {
      this.$nextTick(function() {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      });
    },
    checkAuth() {
      this.axios
        .post("nextgen/authenticate")
        .then(() => {
          this.redirect();
        })
        .catch(() => {});
    },
    search() {
      this.notFound = false;
      this.tooManyFound = false;
      this.error = false;
      this.loading = true;
      this.axios
        .post("/person/search", {
          firstName: this.first_name,
          lastName: this.last_name,
          dob: this.date_of_birth,
          phone: this.phone_number.replace(/[^A-Z0-9]+/gi, ""),
        })
        .then((res) => {
          if (res.data.shouldBlockForInactivity) {
            this.shouldBlockForInactivity = true;
            return;
          }
          return this.axios.post("/nextgen/sendcode", {
            phone: this.phone_number.replace(/[^A-Z0-9]+/gi, ""),
          });
        })
        .then((response) => {
          if (this.shouldBlockForInactivity) {
            this.scrollTop();
            this.loading = false;
            return;
          }
          this.channel = response.data.channel;
          this.step = 3;
          this.scrollTop();
          this.loading = false;
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status == 404) {
              this.notFound = true;
            } else if (error.response.status == 403) {
              this.tooManyFound = true;
            } else if (error.response.status == 429) {
              this.tooManyAttempts = true;
            } else if (error.response.status == 406) {
              this.cookieError = true;
            } else if (error.response.status == 500) {
              this.error = true;
            }
          } else {
            this.error = true;
          }
          this.loading = false;
        });
    },
    resendCode(channel) {
      return this.axios.post("nextgen/sendcode", {
        phone: this.phone_number.replace(/[^A-Z0-9]+/gi, ""),
        channel: channel,
      });
    },
    verify() {
      this.incorrectCode = false;
      this.loading = true;
      return this.axios
        .post("nextgen/verifyCode", {
          phone: this.phone_number,
          code: this.verification_code,
        })
        .then((response) => {
          if (response.status == 200) {
            this.redirect();
          } else {
            this.incorrectCode = true;
            this.verification_code = "";
            this.loading = false;
            console.log("wrong code");
          }
        })
        .catch(() => {
          this.error = this.$t("error.couldNotVerify");
          this.expiredCode = true;
          this.verification_code = "";
          this.loading = false;
          this.step = 2;
          this.scrollTop();
        });
    },
    redirect() {
      let routeName = this.$route.name;
      if (routeName === "formLanding") {
        this.$router.push({ name: "forms", params: { id: "PHQ" } });
      } else {
        this.$router.push(
          this.$i18nRoute({
            name: this.$route.query.redirect || "home",
          })
        );
      }
    },
  },
};
</script>
<style scoped>
.slide-y-transition-enter-active {
  transition-duration: 0.5s;
}
.slide-x-transition-enter-active {
  transition-duration: 1s;
}
.slide-x-transition-leave-active {
  display: none;
}
.slide-y-transition-leave-active {
  display: none;
}
</style>
